<template>
    <div v-if="ready" class="container map-container" :class="{ 'map-container--zen-mode': isZenMode }">
        <div class="row" :class="{ h100: isZenMode }" style="flex-wrap: nowrap;">
            <!-- Sidebar. -->
            <div :class="isZenMode
                ? 'col-lg-3 map-container__sidebar--zen-mode'
                : 'col-lg-3'
                ">
                <div class="map-container__sidebar">
                    <div>
                        <h2>Trasa i punkty na trasie</h2>
                        <p class="mat16">
                            Klasyfikacja
                        </p>
                        <base-input-select v-model="selectedClassification" class="mat8 map-container__sidebar-select"
                            :options="classifications" label-select="namePl" label="Klasyfikacja"
                            :error.sync="errors.classification" />
                        <p class="mat16">
                            Dodaj trasę w pliku .gpx
                        </p>

                        <base-input-file :key="inputFileKey" v-model="trackFileList" class="mat8" :class="{
                            'map-container__sidebar-file': !isZenMode,
                        }" hint="Wybierz plik" :disabled="disabledInput" @input="createGpx()" @click="
                            disabledInput
                                ? (errors.classification =
                                    'Wybierz klasyfikacje')
                                : ''
                            " />
                        <base-button class="mat16" btn2 icon="fas fa-plus" @click="addPoint()">
                            Dodaj punkt
                        </base-button>
                    </div>
                    Tracking obłsugiwany przez:
                    <img class="img-fluid mal24" src="@/assets/images/logo-ap-white.png" style="max-width:200px" @click="
                        $router.push({
                            path: `http://tracking.activeprogress.eu`,
                            tab: true,
                        })
                        ">
                    <base-button :class="{ 'status-btn--positive': shortName }" btn2 icon="fas fa-mobile-alt"
                        class="mat8" @click="showPopupForActivationGPS = !showPopupForActivationGPS">
                        Mobile tracking: {{ shortName ? 'aktywny' : 'Aktywuj' }}
                    </base-button>
                    <base-popup v-if="showPopupForActivationGPS">
                        <!-- Title. -->
                        <template #title>
                            <span v-if="!shortName">
                                Aktywuj tracking dla urządzeń z aplikacją w telefonie.
                            </span>
                            <span v-else>
                                Prefix dla Twoich urządzeń to: <span class="mal8">
                                    <b>{{ shortName }}-</b></span>
                            </span>
                        </template>
                        <!-- Subtitle. -->
                        <template #subtitle>
                            <span v-if="shortName">
                                <b>Aktualny koszt:</b> {{ actualPrice }} PLN <br />
                            </span>
                        </template>
                        <!-- Content. -->
                        <template #content>
                            <div :class="{ 'mat16': shortName }">
                                <span v-if="!shortName">
                                    <b>Aktywujesz możliwość korzystania z telefonów jako urządzeń GPS.</b>
                                </span>
                                <span v-else>
                                    <b>Utworzono:</b> {{ `${devicesAvailable} urządzeń.` }} <br />
                                </span>
                                <!-- middle buttons -->
                                <span v-if="devicesAvailable > 0" class="buttonsRow">
                                    <BaseButtonDownloadGPS class="mar15" btn4
                                        :url="`/gps/competition/${competition.id}/list`"
                                        :fileName="`${competition.name}-v${competition.id}-GPS_List.csv`">
                                        Lista urządzeń
                                    </BaseButtonDownloadGPS>
                                    <base-button
                                        :icon="isCreating ? 'fas fa-spinner fa-spin' : (pplAssigned ? 'fas fa-check-circle' : null)"
                                        class="mal15" btn4 @click="assignExisting()">
                                        {{ isCreating ? 'Przypisuje...' : (pplAssigned ? `Przypisano: ${pplAssigned}` :
                                            'Przypisz istniejące') }}
                                    </base-button>
                                </span>
                                <div v-if="!shortName" class="mat16">
                                    <base-input-text withoutErrorMessage v-model="competitionPrefix" class="mat8 bgc"
                                        hint="Wybierz prefix, dla Twoich urządzeń." :error.sync="errors.prefix" />
                                    <b>Uwaga:</b> <span :class="{ 'c-negative': errors.prefix }">{{ errors.prefix ?
                                        errors.prefix : 'Wybór prefixu jest obowiązkowy'
                                    }}.</span>
                                </div>
                                <div class="mat16">
                                    <span v-if="!shortName">
                                        <b>Aktywacja urządzeń</b> spowoduje, że urządzenia mobilne (telefon, tablet)
                                        będą mogły być używane jako urządzenia GPS do trackingu zawodników na tej
                                        imprezie.
                                        <br />
                                    </span>
                                    <span>
                                        <b>Wymagania:</b> urządzenie musi mieć zainstalowaną aplikację
                                        <b>ActiveProgress</b> lub <b><a href="https://www.traccar.org/client/"
                                                target="_blank">Traccar-Client</a></b>.
                                    </span>
                                    <div class="mat16">
                                        <a href="http://dostartu.pl/files/web/konfiguracja_traccar.pdf" target="_blank">
                                            <b>Instrukcja</b> poprawnego uruchomienia aplikacji
                                            <b>Traccar-Client</b>.
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <!-- Buttons. -->
                        <template #buttons>
                            <base-button class="mar15" btn2 @click="
                                (showPopupForActivationGPS = false),
                                (errors.prefix = '')
                                ">
                                {{ shortName ? 'zamknij' : 'anuluj' }}
                            </base-button>
                            <base-button class="mal15" btn1 @click="
                                (shortName ? (showPopupForAddDevices = true, showPopupForActivationGPS = false) : mGPSactivate())
                                ">
                                {{ shortName ? 'dodaj wiecej' : 'aktywuj' }}
                            </base-button>
                        </template>
                    </base-popup>
                    <!-- Add more devices -->
                    <base-popup v-if="showPopupForAddDevices">
                        <!-- Title. -->
                        <template #title>
                            Dodaj wiecej urządzeń pomiarowych.
                        </template>
                        <!-- Content. -->
                        <template #content>
                            <div>
                                <b>Wybierz</b> sposób dodania urządzeń.
                                <base-input-radio v-model="addBy" :options="[
                                    { value: 'cls', title: 'classifications' },
                                    { value: 'numbers', title: 'Zakres numerów' },
                                ]">
                                </base-input-radio>
                                <div v-if="addBy === 'cls'" class="mat16">
                                    <b>Zaznacz</b> klasyfikacje dla których chcesz dodać urządzenia.
                                    <BaseInputCheckbox class="mat8" v-for="(cls, index) in classifications" :key="index"
                                        v-model="classifications[index].checked"
                                        :checkbox-value="classifications[index].checked" :name="`cls_ids[${index}]`">{{
                                            cls.namePl }}</BaseInputCheckbox>
                                    <b>Uwaga:</b> Utworzone zostaną urządzenia jedynie dla zawodników, z przypisanymi
                                    numerami startowymi.
                                </div>
                                <div v-if="addBy === 'numbers'" class="mat16">
                                    <b>Wybierz</b> zakres numerów startowych, dla których chcesz dodać urządzenia.
                                    <base-input-text type='text' v-model="startNumber" class="mat8 bgc"
                                        label="Od numeru" hint="Początkowy" :error.sync="errors.startNumber" 
                                        @input="startNumber = startNumber.toString().replace(/\D/g, '').slice(0, 4)" />
                                    <base-input-text type='text' v-model="endNumber" class="mat8 bgc" hint="Końcowy"
                                        label="Do numeru" :error.sync="errors.endNumber" 
                                        @input="endNumber = endNumber.toString().replace(/\D/g, '').slice(0, 4)" />
                                </div>
                                <div class="mat16">
                                    <span class="c-negative" v-if="typeof additionalPrice === 'string'">
                                        <b>
                                            Przekroczony limit, jednocześnie można dodać max. 300 urządzeń.
                                        </b>
                                    </span>
                                    <span v-else>
                                        <span>
                                            <b>Koszt aktywacji</b> {{ newTrackers }} dodatkowych urządzeń:<b> {{
                                                additionalPrice
                                                }} PLN</b> <br />
                                        </span>
                                        <span class="c-negative">
                                            <b>Koszt łączny</b> po aktywacji urządzeń:<b> {{ summaryPrice }} PLN</b>
                                            <br />
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </template>
                        <!-- Buttons. -->
                        <template #buttons>
                            <base-button class="mar15" btn2 @click="
                                (showPopupForAddDevices = false),
                                (errors.prefix = '')
                                ">
                                {{ shortName ? 'zamknij' : 'anuluj' }}
                            </base-button>
                            <base-button :icon="isCreating ? 'fas fa-spinner fa-spin' : null"
                                :disabled="isCreating || !!errors.limitDevices" class="mal15" btn1 @click="((isCreating = true),
                                    mGPSactivate()
                                )">
                                {{ `+${newTrackers}` }} Aktywuj
                            </base-button>
                        </template>
                    </base-popup>
                    <div class="row">
                        <base-button btn2 class="mat16" @click="
                            $router.push({
                                path: `http://tracking.activeprogress.eu/${competition.name}-v${competition.id}`,
                                tab: true,
                            })
                            ">
                            Twój tracking GPS
                        </base-button>
                        <base-button btn2 class="mat16 size48" icon="fas fa-user-cog" @click="
                            $router.push({
                                path: `http://tracking.activeprogress.eu/${competition.name}-v${competition.id}?key=${competition.apiKey}`,
                                tab: true,
                            })
                            ">
                        </base-button>
                    </div>
                </div>
            </div>

            <!-- Map. -->
            <div :class="isZenMode
                ? 'col-lg-9 map-container__map--zen-mode'
                : 'col-lg-9'
                ">
                <map-competition :competition="competition" :classifications="classifications"
                    :selected-classification.sync="selectedClassification" @delete-point="onDeletePointClick"
                    @ready="map = $event" />
            </div>
            <!-- Popup. -->
            <base-popup v-if="showPopupForRemove">
                <!-- Title. -->
                <template #title>
                    Usuń punkt
                </template>
                <!-- Subtitle. -->
                <template #subtitle>
                    <b>Czy na pewno, chcesz usunąć wybrany punkt?</b>
                </template>
                <!-- Content. -->
                <template #content>
                    <div class="mat16">
                        Zostanie on usunięty z
                        <b>wszystkich klasyfikacji</b>
                        . Aby nie był wyświetlany w tej klasyfikacji, nie
                        wybieraj żadnej kategorii w punkcie (nie wybrane Start,
                        Meta, Pomiar, Punkt żywieniowy)
                    </div>
                </template>
                <!-- Buttons. -->
                <template #buttons>
                    <base-button class="mar15" btn2 @click="
                        (showPopupForRemove = !showPopupForRemove),
                        (pointToDelete = null)
                        ">
                        anuluj
                    </base-button>
                    <base-button class="mal15" btn1 @click="
                        (showPopupForRemove = !showPopupForRemove),
                        deletePoint()
                        ">
                        Usuń punkt
                    </base-button>
                </template>
            </base-popup>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { mapGetters, mapActions } from 'vuex';
import {
    READ_PANEL_COMPETITION,
    READ_COMPETITION_CLASSIFICATIONS,
    CREATE_LOCATION,
    CREATE_TRACKPOINT,
    DELETE_TRACKPOINT,
    DELETE_LOCATION,
    CREATE_CLASSIFICATION_GPX_FILE,
} from '@/store/actions.type';
import { TRACKPOINT_TYPES } from '@/config';
import MapCompetition from '@/components/MapCompetition';
import { debounce } from 'lodash';
import BaseButtonDownloadGPS from '@/components/BaseButtonDownloadGPS.vue';

export default {
    components: {
        MapCompetition,
        BaseButtonDownloadGPS,
    },
    props: {
        id: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            ready: false,
            selectedClassification: null,
            map: undefined,
            showPopupForRemove: false,
            showPopupForAddDevices: false,
            pointToDelete: null,
            confirmDeletePoint: false,
            trackFileList: [],
            errors: {},
            inputFileKey: 0,
            showPopupForActivationGPS: false,
            devicesAvailable: 0,
            competitionPrefix: '',
            temporaryShortName: null,
            startNumber: 1,
            endNumber: 1,
            addBy: 'cls',
            summaryPrice: 0,
            additionalPrice: 0,
            newTrackers: 0,
            isCreating: false,
            pplAssigned: null,
        };
    },
    computed: {
        ...mapGetters(['competitions', 'classificationsBy', 'isZenMode']),
        competition() {
            return this.competitions[this.id];
        },
        actualPrice() {
            return this.summaryPrice - this.additionalPrice;
        },
        classifications() {
            return this.classificationsBy(this.competition);
        },
        selectedClassifications() {
            return this.classifications.filter(cls => cls.checked).map(
                (cls) => (cls.id),
            );
        },
        disabledInput() {
            return !this.selectedClassification;
        },
        shortName() {
            return this.competition?.shortName || this.temporaryShortName;
        },
    },
    async created() {
        await Promise.all([
            this.READ_PANEL_COMPETITION(this.id),
            this.READ_COMPETITION_CLASSIFICATIONS(this.id),
        ]);
        this.ready = true;
    },
    watch: {
        showPopupForActivationGPS(newVal) {
            if (newVal === true) {
                this.checkActivationPrice()
                this.checkAvailableDevices()
            }
        },
        startNumber(newVal) {
            if (newVal && newVal > this.endNumber) {
                this.endNumber = newVal;
            }
        },
        addBy() {
            if (this.addBy === 'cls') {
                this.checkActivationPrice(this.selectedClassifications);
            }
            if (this.addBy === 'numbers') {
                this.checkActivationPrice(null, this.startNumber, this.endNumber);
            }
        },
        endNumber(newVal, oldVal) {
            if (newVal == oldVal) {
                return;
            }
            if (newVal && newVal < this.startNumber) {
                this.errors.endNumber = 'Numer końcowy musi być większy lub równy początkowemu';
                this.endNumber = this.startNumber;
            }
            if (newVal !== oldVal) {
                debounce(() => {
                    this.checkActivationPrice(
                        null,
                        this.startNumber,
                        this.endNumber,
                    );
                }, 500)();
            }
        },
        selectedClassifications(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return;
            }
            debounce(() => {
                this.checkActivationPrice(
                    this.selectedClassifications,
                    null,
                    null
                );
            }, 500)();
        },
    },
    methods: {
        ...mapActions([
            READ_PANEL_COMPETITION,
            READ_COMPETITION_CLASSIFICATIONS,
            CREATE_LOCATION,
            CREATE_TRACKPOINT,
            DELETE_LOCATION,
            DELETE_TRACKPOINT,
            CREATE_CLASSIFICATION_GPX_FILE,
        ]),
        async addPoint() {
            const centerMap = this.map.getBounds().getCenter();
            const locationId = await this.CREATE_LOCATION({
                lat: centerMap.lat,
                lng: centerMap.lng,
            });

            await this.CREATE_TRACKPOINT({
                location: locationId,
                type: TRACKPOINT_TYPES.checkpoint,
                classifications: this.classifications.map(
                    (classification) => classification.id,
                ),
            });
        },
        onDeletePointClick(point) {
            this.showPopupForRemove = true;
            this.pointToDelete = point;
        },
        async deletePoint() {
            const promises = [];
            const trackpointsIds = Object.values(
                this.pointToDelete.trackpoints,
            );
            for (const id of trackpointsIds) {
                promises.push(this.DELETE_TRACKPOINT(id));
            }

            await Promise.all(promises);
            await this.DELETE_LOCATION(this.pointToDelete.location);
            this.pointToDelete = null;
        },
        async assignExisting() {
            this.isCreating = true;
            try {
                const response = await api.post(`gps/competition/${this.competition.id}/assign-existing`);
                this.pplAssigned = response.assigned
            } catch (error) {
                console.error('Error assigning existing devices:', error);
            }
            this.isCreating = false;
        },
        async createGpx() {
            await this.CREATE_CLASSIFICATION_GPX_FILE({
                id: this.selectedClassification.id,
                gpxFile: this.trackFileList[0],
            });
            this.trackFileList = [];
            this.inputFileKey += 1
        },
        async checkAvailableDevices() {
            try {
                const response = await api.get(`gps/competition/${this.competition.id}/count`);
                this.devicesAvailable = response.available ? response.available : 0;
            } catch (error) {
                console.error('Error checking available devices:', error);
            }
        },
        async createmGPSDevices(shortName, startNumber, endNumber, classificationIds) {
            if (classificationIds && classificationIds.length === 0) {
                classificationIds = null;
            }
            if (shortName && shortName.length >= 2) {
                try {
                    const response = await api.post(`gps/competition/${this.competition.id}/bulk`, {
                        shortName,
                        startNumber,
                        endNumber,
                        classificationIds,
                    })
                    if (response.success) {
                        this.temporaryShortName = this.competitionPrefix.toUpperCase()
                        this.showPopupForActivationGPS = false;
                    }
                } catch (error) {
                    console.error('Error creating mGPS devices:', error);
                };
                this.isCreating = false;
            }
        },
        async checkActivationPrice(selectedClassifications, startNumber, endNumber) {
            if (selectedClassifications && selectedClassifications.length === 0) {
                selectedClassifications = null;
            }
            const response = await api.post(`gps/competition/${this.competition.id}/bulk/cost`, {
                startNumber: startNumber || null,
                endNumber: endNumber || null,
                classificationIds: selectedClassifications || null,
            });
            this.summaryPrice = response.summaryPrice || 0;
            this.additionalPrice = response.price || 0;
            this.newTrackers = response.newTrackers || 0;
            if (response.newTrackers > 300) {
                this.errors.limitDevices = 'Osiągnięto limit urządzeń, nie można dodać więcej niż 300 naraz.';
            }
            else {
                this.errors.limitDevices = null;
            }

        },
        async mGPSactivate() {
            let prefixStatus
            if (this.shortName) {
                if (this.addBy === 'cls') {
                    await this.createmGPSDevices(this.shortName, null, null, this.selectedClassifications);
                } else {
                    await this.createmGPSDevices(this.shortName, this.startNumber, this.endNumber, null);
                }
                this.showPopupForActivationGPS = !this.showPopupForActivationGPS;
                this.showPopupForAddDevices = !this.showPopupForAddDevices;
                return;
            }
            if (this.competitionPrefix.length < 2) {
                this.errors.prefix = 'Prefix musi składać się z min. 2 wielkich liter';
                this.competitionPrefix = '';
                return;
            }
            prefixStatus = await api.get(`/competition/shortname/${this.competition.id}/check?shortName=${this.competitionPrefix.toUpperCase()}`)
            if (!prefixStatus.available) {
                this.errors.prefix = 'Ten prefix jest już zajęty, wybierz inny';
            }
            if (prefixStatus.available) {
                this.competitionPrefix = this.competitionPrefix.toUpperCase();
                await this.createmGPSDevices(this.competitionPrefix);
            }
        },
        trackClickHandler(track) {
            const clickedClassification = this.classifications.filter(
                (classification) => classification.id === track.classification,
            );
            const [classification] = clickedClassification;
            this.selectedClassification = classification;
        },
    },
};
</script>

<style scoped>
.size48 {
    padding: 4px;
}

.bgc {
    background-color: var(--color-silver);
}

.buttonsRow {
    display: flex;
    padding: 8px;
    background-color: var(--color-white);
}

.buttonsRow>.btn {
    box-sizing: border-box;
    text-transform: uppercase;
    width: 100%;
    background-color: var(--color-silver);
}

.status-btn--positive {
    background-color: var(--color-dark-pastel-green);
}

.map-container__map {
    height: 600px;
    width: 100%;
    overflow: hidden;
    border-radius: 4px;
}

.map-container {
    border-radius: 4px;
    background-color: var(--color-slate);
    padding: 0;
    margin-top: 40px;
}

.map-container__sidebar {
    height: 100%;
    padding: 24px 30px 24px 24px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    justify-content: space-between;
    max-width: 270px;
}

.map-container__sidebar-select>>>.vs__selected {
    white-space: normal;
    padding-top: 5px;
}

.map-container__sidebar-file {
    max-width: 238.5px;
}

.map-container--zen-mode {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    max-width: unset;
}

.map-container__sidebar--zen-mode {
    max-width: 380px;
}

.map-container__map--zen-mode {
    flex-grow: 1;
}
</style>
